export enum InquireShahkarErrors {
  ErrServerNeedsHelp = 100,
}

export const InquireShahkarErrorMessages = {
  [InquireShahkarErrors.ErrServerNeedsHelp]: "خطا در اتصال به سرور",
};
